import { DedicatedDriverPreferencesOutput } from '@allocab/allocab-dedicated-driver-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { driverApi } from '../services/network/Api';

const fetchDrivePreferencesById = (id: string) =>
  driverApi.get<void, DedicatedDriverPreferencesOutput>(`/v1/dedicated-driver-preferences/driver/${id}`);

export const useFetchDriverPreferencesById = (id: string) =>
  useQuery(queryKeys.user.fetchDrivePreferencesById(id), () => fetchDrivePreferencesById(id));
